export default function PortalSection() {
  return (
    <section className="qs" id="s1">
      <div className="wrap">
        <div className="qhd pd-rv">
          <div>
            <span className="ey">
              <b>01</b>
              포탈 구성
            </span>
            <small>만드는 사람도, 사용하는 사람도 편리하게</small>
            <h2>
              관리자·사용자
              {' '}
              <em>포탈 구성</em>
            </h2>
          </div>
        </div>
        <div className="qpt">
          <div className="qpc a pd-rv" id="p-admin">
            <span className="ey2">AI Agent를 만들고 운영하는 공간</span>
            <h3>
              관리자 포탈
              <span className="tag">ADMIN</span>
            </h3>
            <div className="vis">
              <div className="sh">
                <img src="/site/home/admin-dashboard.png" alt="관리자 대시보드" />
              </div>
              <div className="fl toast" style={{ left: "24px", bottom: "24px", position: "absolute" }}>
                <i>
                  <svg className="i">
                    <use href="#check" />
                  </svg>
                </i>
                AI Agent 배포 완료
                <span>방금</span>
              </div>
            </div>
            <div className="qfeat">
              <div>
                <i>
                  <svg className="i">
                    <use href="#layers" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>워크플로우</b>
                  <span>워크플로우를 만들고 목록에서 관리</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#branch" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>워크플로우 빌더</b>
                  <span>필요한 기능을 편집·연결해 워크플로우 배포</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#store" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>마켓플레이스</b>
                  <span>필요한 노드와 도구를 설치하거나 제거</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#copy" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>템플릿</b>
                  <span>배포된 워크플로우를 복사해 내 업무에 맞게 사용</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#book" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>지식 파이프라인</b>
                  <span>지식베이스를 만들고 연결된 데이터를 최신 상태로 유지</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#msg" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>챗봇 테스트</b>
                  <span>배포한 챗봇의 응답을 직접 확인</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#chart" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>관리자 대시보드</b>
                  <span>전체 운영 현황을 통계로 확인</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#users" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>사용자 관리</b>
                  <span>사용자 등록 및 제품·조직(테넌트)·고객사별 권한 관리</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#plug" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>AI 제공자 연결</b>
                  <span>사용할 AI 서비스의 연결 설정 관리</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#building" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>고객사 관리</b>
                  <span>고객사 등록 및 코드·소속 조직(테넌트)·상태 관리</span>
                </p>
              </div>
            </div>
          </div>
          <div className="qpc u pd-rv d1" id="p-user">
            <span className="ey2">업무에 필요한 지식을 모으고 AI를 사용하는 공간</span>
            <h3>
              사용자 포탈
              <span className="tag">USER</span>
            </h3>
            <div className="vis">
              <div className="sh">
                <img src="/site/screens/user-dashboard.png" alt="사용자 대시보드" />
              </div>
              <div className="fl ui" style={{ left: "24px", bottom: "24px", width: "186px" }}>
                <div className="kpi">
                  <small>
                    <span className="dt" style={{ background: "var(--teal)" }} />
                    사용 가능한 챗봇
                  </small>
                  <b>
                    4
                    <em>개</em>
                  </b>
                  <div className="pr">
                    <i style={{ width: "100%", background: "var(--teal)" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="qfeat">
              <div>
                <i>
                  <svg className="i">
                    <use href="#grid" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>대시보드</b>
                  <span>내 워크플로우·사용 가능한 챗봇·실행 중인 예약 작업 확인</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#msg" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>챗봇</b>
                  <span>배포된 챗봇을 찾아 선택하고 실시간으로 대화</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#history" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>최근 대화 이력</b>
                  <span>이전에 나눈 대화 내용을 다시 확인</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#book" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>지식 파이프라인</b>
                  <span>개인 파일·웹 등의 데이터를 모아 지식베이스 생성·관리</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#upload" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>파일 업로드</b>
                  <span>PDF · TXT · Markdown · Excel 파일 업로드</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#layers" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>워크플로우</b>
                  <span>워크플로우 만들기·편집과 배포 상태 확인</span>
                </p>
              </div>
              <div>
                <i>
                  <svg className="i">
                    <use href="#copy" />
                  </svg>
                </i>
                <p style={{ margin: "0" }}>
                  <b>워크플로우 템플릿</b>
                  <span>챗봇·예약 실행(스케줄) 템플릿 검색 및 실행</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="pnote pd-rv">
          <span>관리자는 AI Agent를 만들고 조직의 사용 환경을 관리합니다.</span>
          <span>사용자는 받은 권한에 따라 지식·업무 흐름을 만들고 AI Agent를 사용합니다.</span>
        </div>
      </div>
    </section>
  );
}
